<template>
  <button class="btn btn-blue btn-fast-bid-confirm" @click="placeBid">
    {{ trans("lot.confirmation.buttons.confirm_bid") }}
  </button>
</template>

<script setup lang="ts">
  import { trans } from "@/utils/trans";

  const emit = defineEmits(["placeBid"]);

  const placeBid = () => {
    emit("placeBid");
  };
</script>
